import useIconColor from '../../hooks/useIconColor';

const Github = () => {
  const { foreground, background } = useIconColor();

  return (
    <svg width='22' height='22' viewBox='0 0 22 22' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <rect width='22' height='22' rx='11' fill={foreground} />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M10.999 0C4.92483 0 0 4.92483 0 11.0003C0 15.8603 3.15154 19.9829 7.52264 21.4382C8.07299 21.5388 8.27355 21.1991 8.27355 20.9074C8.27355 20.6467 8.2641 19.9546 8.25869 19.0369C5.19899 19.7013 4.55342 17.562 4.55342 17.562C4.05304 16.2918 3.33184 15.9535 3.33184 15.9535C2.3331 15.2708 3.40747 15.2843 3.40747 15.2843C4.51156 15.3627 5.0923 16.4181 5.0923 16.4181C6.07348 18.0989 7.66715 17.6134 8.29381 17.3325C8.39375 16.6214 8.67737 16.1365 8.99205 15.8617C6.54956 15.5841 3.98146 14.6401 3.98146 10.425C3.98146 9.22435 4.41026 8.24249 5.11391 7.47334C5.00046 7.19512 4.62298 6.07686 5.22128 4.5622C5.22128 4.5622 6.14506 4.26643 8.24654 5.68992C9.12373 5.44614 10.0651 5.32392 11.0003 5.31987C11.9343 5.32392 12.8756 5.44614 13.7541 5.68992C15.8543 4.26643 16.776 4.5622 16.776 4.5622C17.3763 6.07686 16.9989 7.19512 16.8854 7.47334C17.5904 8.24249 18.0165 9.22435 18.0165 10.425C18.0165 14.6509 15.4444 15.5808 12.9938 15.8529C13.3888 16.1926 13.7406 16.8638 13.7406 17.8902C13.7406 19.3603 13.7271 20.5468 13.7271 20.9074C13.7271 21.2018 13.925 21.5442 14.4834 21.4368C18.8512 19.9789 22 15.859 22 11.0003C22 4.92483 17.0745 0 10.999 0Z'
        fill={background}
      />
    </svg>
  );
};

export default Github;
